import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultCanvasLineRender } from "./line-render";

import { GraphicRender, LineRender } from "./symbol";

const loadedLineModuleContexts = new WeakSet;

export function bindLineRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedLineModuleContexts, bind) || (bind(DefaultCanvasLineRender).toDynamicValue((() => new DefaultCanvasLineRender)).inSingletonScope(), 
    bind(LineRender).toService(DefaultCanvasLineRender), bind(GraphicRender).toService(LineRender));
}

export const lineModule = bindLineRenderModule;
//# sourceMappingURL=line-module.js.map
